import { useReducer } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import { ImageUploadContext } from './context';
import type { ImageUploadState } from './context';
import { imageUploadReducer } from './reducer';

export const defaultContext: ImageUploadState = {
	image: undefined,
	imageChanged: false,
	imageCrop: undefined,
	errorMessage: null,
	fileType: null,
	cropper: undefined,
};

export const ImageUploadProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const [state, dispatch] = useReducer(imageUploadReducer, defaultContext);

	const value = {
		state,
		dispatch,
	};
	return <ImageUploadContext.Provider value={value}>{children}</ImageUploadContext.Provider>;
};
